import { refineServiceDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { ILayoutService } from 'monaco-editor/esm/vs/platform/layout/browser/layoutService.js';
const IWorkbenchLayoutService = refineServiceDecorator(ILayoutService);
function positionToString(position) {
    switch (position) {
        case 0 : return 'left';
        case 1 : return 'right';
        case 2 : return 'bottom';
        default: return 'bottom';
    }
}
export { IWorkbenchLayoutService, positionToString };
